import { jsx as _jsx } from "react/jsx-runtime";
import { CatIconBatteryFull } from "blocks-nextjs/blocks-react/components/Icons/BatteryFull/BatteryFull";
import { CatIconBatteryLow } from "blocks-nextjs/blocks-react/components/Icons/BatteryLow/BatteryLow";
import { CatIconBatteryMedium } from "blocks-nextjs/blocks-react/components/Icons/BatteryMedium/BatteryMedium";
import chargingGif from "../assets/Charging.gif";
export const getChargingIcon = (dataTest) => (_jsx("img", { alt: "Charging", className: "h-[14px] w-[24px]", "data-test": dataTest, src: chargingGif }));
export const getBatteryIcon = (soc, size = "lg", color) => {
    const BATTERY_FIFTY = 50;
    const BATTERY_FIFTEEN = 15;
    if (soc >= BATTERY_FIFTY) {
        return _jsx(CatIconBatteryFull, { color: color || "success", "data-test": "CatIconBatteryFull", size: size });
    }
    else if (soc < BATTERY_FIFTY && soc >= BATTERY_FIFTEEN) {
        return _jsx(CatIconBatteryMedium, { color: color || "knockout-brand", "data-test": "CatIconBatteryMedium", size: size });
    }
    else if (soc < BATTERY_FIFTEEN && soc > 0) {
        return _jsx(CatIconBatteryLow, { color: color || "error", "data-test": "CatIconBatteryLow", size: size });
    }
    else {
        return _jsx(CatIconBatteryMedium, { color: color || "error", "data-test": "CatIconError", size: size });
    }
};
